import type { Opt } from '@jet/environment/types/optional';
import type {
    Persistence as IPersistence,
    PersistenceScope,
    SerializableValue,
} from '@jet-app/music-classical/utilities/storage/Persistence';
import type { StorageKey } from '@jet-app/music-classical/utilities/storage/StorageKeys';
import type { Logger, LoggerFactory } from '@amp/web-apps-logger';

export const STORAGE_KEY_PREFIX = 'classical+pref:';

export class Persistence implements IPersistence {
    private readonly log: Logger;

    constructor(loggerFactory: LoggerFactory) {
        this.log = loggerFactory.loggerFor('jet/dependencies/persistence');
    }

    getValueForKey(
        key: StorageKey,
        scope: PersistenceScope,
    ): Opt<SerializableValue> {
        // TODO: handle scope: rdar://87546165 (Web Music Jet: Follow-up: Persistence dependency: add support for scoping)

        // Window is not available in SSR
        if (typeof window === 'undefined') return;

        const serializedValue = window.localStorage.getItem(getKey(key, scope));

        if (!serializedValue) return;

        try {
            const value = JSON.parse(serializedValue);
            return value;
        } catch (e) {
            this.log.debug(e);
        }
    }

    setValueForKey(
        key: StorageKey,
        value: SerializableValue,
        scope: PersistenceScope,
    ) {
        // TODO: handle scope: rdar://87546165 (Web Music Jet: Follow-up: Persistence dependency: add support for scoping)

        // Window is not available in SSR
        if (typeof window === 'undefined') return;

        this.log.info(`set persistence value for ${key}:`, value);

        const newValue = value;

        try {
            window.localStorage.setItem(
                getKey(key, scope),
                JSON.stringify(newValue),
            );
        } catch (e) {
            this.log.debug(e);
        }
    }
}

function getKey(
    key: StorageKey,
    _scope: PersistenceScope,
    userId: string = null,
): string {
    // TODO: different keys for different scopes (User / Device)
    // rdar://87546165 (Web Music Jet: Follow-up: Persistence dependency: add support for scoping)
    return [`${STORAGE_KEY_PREFIX}${key}`, userId].filter(Boolean).join('-');
}
